export default __webpack_public_path__ + "static/media/play-store-mini-2x.73b33f2d.png";